<template>
  <div
    class="payable-list-main-wrapper cbg-white-container input-container theme--light v-card border-card"
  >
    <CCol sm="12">
      <CRow>
        <CCol sm="6" md="3" class="form-group search-div">
          <label for>Search</label>
          <div class="col-sm-12 p-0 search-div position-relative">
            <input
              v-model="search"
              @input="fetchWithdrawal"
              type="text"
              class="form-control"
              placeholder="Search"
            />
            <!-- <div class="search-svg">
              <searchSVG />
            </div>-->
            <div
              v-if="search !== ''"
              class="search-svg position-absolute"
              @click="clearSearch()"
            >
              <crossSVG />
            </div>
          </div>
        </CCol>
        <CCol sm="6" md="3" class="datepicker pos-r">
          <label for class="d-block-mob">Date Range</label>
          <datepicker
            v-model="dateRange"
            ref="datepicker"
            :model-config="datePickerConfig"
            :max-date="new Date()"
            is-range
            :masks="{ input: 'DD-MM-YYYY' }"
            @input="onDateChange"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <input
                :value="
                  !!inputValue.start && !!inputValue.end
                    ? inputValue.start + ' - ' + inputValue.end
                    : 'DD/MM/YYYY'
                "
                v-on="inputEvents.start"
                class="form-control position-relative"
                placeholder="DD-MM-YYYY"
              />
              <div
                v-if="!!inputValue.start && !!inputValue.end"
                class="cross-svg"
                @click="resetActiveDate"
              >
                <crossSVG />
              </div>
            </template>
          </datepicker>
          <div class="calendarsvg userinputcalendar pos-a">
            <calendarSVG />
          </div>
        </CCol>
        <CCol sm="6" md="3">
          <div class="position-relative">
            <label for>Filter by status</label>
            <select
              v-model="status"
              @change="fetchWithdrawal"
              name
              id
              class="form-control"
            >
              <option value="all">All</option>
              <option value="requested">Pending</option>
              <option value="processed">Completed</option>
            </select>
            <span class="drop-icon">
              <i
                aria-hidden="true"
                class="v-icon mdi mdi-menu-down theme--light position-absolute"
              ></i>
            </span>
          </div>
        </CCol>
        <CCol v-if="permissions.includes('CAN_EXPORT_WITHDRAWAL_LIST')" sm="3">
          <label class="col-sm-12 mb-0 d-none-mob1"></label>
          <v-btn v-if="!loading" class="btn btn-primary" @click="exportCSV"
            >Export</v-btn
          >
        </CCol>
      </CRow>
    </CCol>

    <!-- ... end 12 .... -->
    <CCol sm="12">
      <table class="table userlistTable">
        <thead>
          <tr class="table-success">
            <th scope="col">Date</th>
            <th scope="col">Dr Name</th>
            <th scope="col">Amount</th>
            <th scope="col">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!isLoading && listing.length <= 0">
            <td colspan="5" align="center"><h1>No data found</h1></td>
          </tr>
          <tr v-else v-for="entry in listing" :key="entry.withdrawal_id">
            <td>{{ entry.created_at | date }}</td>
            <td class="text-capitalize">{{ entry.name }}</td>
            <td>&#8377; {{ entry.points }}</td>
            <td v-if="entry.status === 'processed'">
              <span class="badge badge-success">{{
                entry.status | status
              }}</span>
            </td>
            <td v-else>
              <span class="badge badge-warning">{{
                entry.status | status
              }}</span>
            </td>
            <td class="action-div small-table-padding">
              <div>
                <CDropdown
                  color="link"
                  size="lg"
                  :caret="false"
                  class="dropdowndocbox"
                >
                  <template #toggler-content>
                    <verticalDotsSVG />
                  </template>
                  <CDropdownItem @click="openDetailsDialog(entry)"
                    >View Details</CDropdownItem
                  >
                  <CDropdownItem @click="walletHistoryDetails(entry)"
                    >View History</CDropdownItem
                  >
                </CDropdown>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </CCol>
    <CPagination
      class="pagination-block mx-3"
      align="end"
      :active-page.sync="page"
      :pages="Math.ceil(total / limit)"
      @update:activePage="onChangePage"
    />
    <withdrawalDetails
      :withdrawalDetailsDialog="withdrawalDetailsDialog"
      :details="details"
      @close="close"
      @save="save"
    />
    <walletHistory :walletHistoryDialog = "walletHistoryDialog" @closeHistory="closeHistory" :walletHistory="walletHistoryData"/>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import "@/assets/scss/_accounts.scss";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
import { pickSvg } from "@/views/SVG";
import withdrawalDetails from "@/views/dashboardNew/Accounts/withdrawalDetails";
import walletHistory from "@/views/dashboardNew/Accounts/walletHistory";
import config from "@/config.js";
import formats from "@/formats.js";
export default {
  data() {
    return {
      isLoading: true,
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      startDate: "",
      endDate: "",
      dateRange: { start: "", end: "" },
      details: {},
      status: "all",
      search: "",
      listing: [],
      withdrawalDetailsDialog: false,
      walletHistoryDialog:false,
      // pagination
      limit: 10,
      offset: 0,
      page: 1,
      total: 0,
      loading: false,
      walletHistoryData :[]
    };
  },
  components: {
    ...pickSvg("incomeSVG", "searchSVG", "verticalDotsSVG", "crossSVG"),
    Datepicker,
    withdrawalDetails,
    walletHistory
  },

  computed: {
    ...mapGetters({
      permissions: "getPermissions",
    }),
  },

  mounted() {
    this.fetchWithdrawal();
  },
  filters: {
    date(val) {
      return dayjs(val).format(formats.date_time_format);
    },
    status(val) {
      let status = "Pending";
      if (val === "processed") {
        status = "Processed";
      }
      return status;
    },
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    resetActiveDate() {
      this.dateRange = { start: "", end: "" };
      this.startDate = "";
      this.endDate = "";
      this.fetchWithdrawal();
    },
    onChangePage(page) {
      console.log(page);
      this.offset = (page - 1) * this.limit;
      this.fetchWithdrawal();
    },
    onDateChange(dateRange) {
      this.startDate = dayjs(dateRange.start).format("YYYY-MM-DD");
      this.endDate = dayjs(dateRange.end).add(1, "day").format("YYYY-MM-DD");
      this.onChangePage(1);
    },
    close() {
      this.withdrawalDetailsDialog = false;
      this.details = {};
    },
    closeHistory(){
      this.walletHistoryDialog = false;
    },
    save(utrNumber) {
      this.$http
        .put(
          `${config.ACCOUNTS_URL}ds-accounts-be/withdrawal/${this.details.withdrawal_id}`,
          { status: "processed", utr_number: utrNumber }
        )
        .then(() => {
          this.withdrawalDetailsDialog = false;
          this.details = {};
          this.fetchWithdrawal();
        });
    },
    openDetailsDialog(details) {
      this.withdrawalDetailsDialog = true;
      this.details = details;
    },
    walletHistoryDetails(details){
      this.walletHistoryDialog = true;
      let url = `${config.ACCOUNTS_URL}ds-accounts-be/v2/admin/wallet?belongs_to=${details.belongs_to}&role=${details.role}`;
      this.$http.get(url).then((response) => {
        let data = response.body.data;
        this.walletHistoryData = data;
        });
    },
    getSearchParams() {
      const params = Object.assign(
        {},
        {
          limit: this.limit,
          offset: this.offset,
        }
      );
      if (this.startDate && this.endDate) {
        params.start = this.startDate;
        params.end = this.endDate;
      }
      if (this.status !== "all") {
        params.status = this.status;
      }
      if (this.search.length > 0) {
        params.global = this.search;
      }
      return params;
    },
    exportCSV() {
      const params = this.getSearchParams();
      this.$http
        .get(`${config.ACCOUNTS_URL}ds-accounts-be/withdrawal/export`, {
          params,
        })
        .then((response) => {
          const uriContent =
            "data:text/csv;charset=utf-8," + encodeURIComponent(response.body);
          const date = dayjs(new Date()).format(formats.date_format);
          const myWindow = window.open(uriContent, `${date}_accounts.csv`);
          myWindow.focus();
        });
    },
    fetchWithdrawal() {
      this.isLoading = true;
      const params = this.getSearchParams();
      this.$http
        .get(`${config.ACCOUNTS_URL}ds-accounts-be/withdrawal/search`, {
          params,
        })
        .then((response) => {
          this.isLoading = false;
          this.total = Number(response.headers.get("query-count"));
          this.listing = response.body;
        });
    },
  },
};
</script>